import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { db } from '../config/firebase/firebaseConfig';
import { Coach } from '../types/coach';
import { Student } from '../types/student';

const COLLECTIONS = {
  coaches: 'coaches',
  students: 'students'
};

export class CoachesService {
  static async getAllCoaches(): Promise<Coach[]> {
    const q = query(
      collection(db, COLLECTIONS.coaches),
      orderBy('createdAt', 'desc')
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt?.toDate() || new Date()
    })) as Coach[];
  }

  static async getStudentsByCoachId(coachId: string): Promise<Student[]> {
    const q = query(
      collection(db, COLLECTIONS.students),
      where('coachId', '==', coachId)
    );

    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt?.toDate() || new Date()
    })) as Student[];
  }
}